import React from "react";

function About() {
  return (
    <div id="about" className="flexbox-container-v page-content">
      <div className="flexbox-container-v">

        <p id="resume" className="content black-font medium-font text-content">
          Hi! Im Stephen, I am a PROGRAMMER ANALYST who strives to
          become a versatile professional who can tackle complex
          challenges and make meaningful impacts in the software
          development industry.

        </p>

        <p id="cdi"className="medium-font text-tag">
          I graduated from CDI College in 2023
        </p>

        <div id="about-tags" className="tag-holder">

          <div className="content">
            <p className="tag-info small-font">Im fluent in:</p>
            <div className="">
              <span className="tag tiny-font">Spanish</span>
              <span className="tag tiny-font">English</span>
              <span className="tag tiny-font">French</span>
            </div>
          </div>

          <div className="content">
            <p className="tag-info small-font">You can contact me at:</p>
            <div className="">
              <span className="tag tiny-font">stephen.paulsen.r@gmail.com</span>
            </div>
          </div>
          
        </div>

        <p id="resume2" className="content medium-font text-content">
          There is immense joy in the process of improvement.
          Updating or completely remaking old stuff in a better and 
          more efficient way brings me an insane sense of accomplishment 
            and helps me better develop new coding ideas.
        </p>
      </div>
    </div>
  );
}

export default About;